import { LocalizationService } from '@abp/ng.core';
import { inject, Injectable, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, Subject, takeUntil } from 'rxjs';
import { localizeWithFallback } from '../utils/localization-utils';

@Injectable({
  providedIn: 'root',
})
export class ZnInitializationHook implements OnDestroy {
  private destroy$ = new Subject<void>();
  private readonly localizationService = inject(LocalizationService);

  constructor(private router: Router) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  initialize() {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe((event: NavigationEnd) => {
        setTimeout(() => {
          this.onNavigationComplete(event);
        }, 0);
      });
  }

  private onNavigationComplete(event: NavigationEnd) {
    this.applyGlobalSettings();
  }

  private applyGlobalSettings(): void {
    this.updateMenuPlaceholder(0);
  }

  private updateMenuPlaceholder(attempt: number): void {
    const input = document.querySelector('.menu-filter-input') as HTMLInputElement;

    if (input) {
      input.placeholder = localizeWithFallback(this.localizationService, 'LeptonX::Search')
    } else if (attempt < 3) {
      setTimeout(() => this.updateMenuPlaceholder(attempt + 1), 200);
    }
  }
}

